module.exports = __webpack_public_path__ + "img/saddle-cloths-20.3ebab676.svg";